export default "__VITE_ASSET__DhixwHji__"